<template lang="pug">
.order
  .p-title 广告发布
  .type_box
    button.type(
      v-for="item in contentTypeList" :key="item.guid"
      :class="{ select: currentType === item.dictItemCode }"
      @click="setType(item.dictItemCode)")
      span {{item.dictItemName}}
      i.circle(v-if="(newsStatus[item.dictItemCode] === '1') && item.dictItemCode")
  .p-main
    .main-box(:class="{'with-page': pageInfo.total > pageInfo.size}")
      .table_box.clearfix(v-loading="loading" v-if="tableData.length || loading" :style="{width: boxWidth + 'px'}")
        .order_box.clearfix(v-for="order in tableData" :class="{empty: !order.advContentDto || !order.advContentDto.customerGuid}")
          OrderVideoItem(:order="order" @changeMatial="setCurrentDetail" :pType="order.mType")
      .table_box(v-else)
        .empty_box
          img(src="../../assets/order_empty.png")
          p 暂无记录哦～
          p 快去投放广告吧～
    Pagination.page_box(
      v-if="pageInfo.total>pageInfo.size" :total="pageInfo.total" :current-page.sync="pageInfo.current" :size.sync="pageInfo.size"
      @fn-change="getList" :autoLoad="false" style="left:20px;")
  UploadVideo(v-model="currentRow" @upDone="getList")
</template>

<script>
import UploadVideo from '@/components/UploadVideo'
import Pagination from '@/components/Pagination'
import OrderVideoItem from './orderVideoItem'
import { getOrderContent, getOrderContentCode } from "@/utils/api"

export default {
  name: 'OrderVideo',
  components: { Pagination, UploadVideo, OrderVideoItem },
  data() {
    return {
      tableData: [],
      // currentType: '',
      currentType: this.$route.query.type || '',
      pageInfo: {
        total: 0,
        current: 1,
        size: 20
      },
      loading: false,
      currentRow: {},
      newsStatus: {},
      contentTypeList: [],
      boxWidth: 0
    }
  },
  computed: {
    wsNewsStatus() {
      return this.$store.state.common.videoStatusNews
    }
  },
  watch: {
    wsNewsStatus(val) {
      this.newsStatus = val
    }
  },
  mounted() {
    let eachBoxW = 505
    let pMainW = document.getElementsByClassName('p-main')[0].clientWidth
    this.boxWidth = Math.floor((pMainW - 20) / eachBoxW) * eachBoxW

    window.addEventListener('resize', () => {
      let pMainW = document.getElementsByClassName('p-main')[0].clientWidth
      this.boxWidth = Math.floor((pMainW - 20) / eachBoxW) * eachBoxW
    })

    this.contentType()
    this.getList()
    this.$store.dispatch('getVideoNewsStatusRes') // 审核状态小红点
  },
  methods: {
    async contentType() {
      let response = await getOrderContentCode()
      this.contentTypeList = [
        { dictItemName: '全部', dictItemCode: '', guid: 0 },
        ...response.data
      ]
    },
    async getList(isReqPageOne) {
      // 更新下公共路由 index.vue 组件中的顶部未发布订单提示展示
      this.$parent.getHandleOrder()

      if (isReqPageOne) this.pageInfo.current = 1

      let param = {
        execStatus: this.currentType,
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size
      }
      let response = await getOrderContent(param)
      this.tableData = []
      this.$nextTick(() => {
        this.tableData = (response.data.list || []).map(el => {
          el.mType = el.showScreenType != 2 ? 0 : 1 // 0竖屏 1横屏
          return el
        })
        this.pageInfo.total = response.data.total
        this.loading = false
        this.$nextTick(() => {
          // 更新tab小红点状态
          this.$store.dispatch('getVideoNewsStatusRes')
          // 顶部消息小红点提示状态
          this.$store.dispatch('getMsgTipStatu')
        })
      })
    },
    setType(type) {
      if (this.loading) return
      this.loading = true
      this.currentType = type
      this.newsStatus[type] = false
      this.pageInfo.current = 1
      this.pageInfo.total = 0
      this.getList()
    },
    setCurrentDetail(row, type) {
      this.currentRow = {
        ...row
      }
      this.currentRow[type] = true

      tzx_czcPush('order_video', type)
    }
  }
}
</script>

<style lang="sass" scoped>
i.iconfont
    margin-top: 2px
    &.icon-shenhezhong
        color: #FF7413
    &.icon-daishangchuan
        color: #999
    &.icon-zhengque
        color: #3FB536
    &.icon-cuowu
        color: #D50000

.type_box
    margin-bottom: 20px
    text-align: center
    background: #212123
    border-radius: 20px
    .type
        position: relative
        width: 120px
        height: 40px
        margin: 0 5px
        border: none
        border-radius: 4px
        background: #3F3F42
        color: #999
        cursor: pointer
        font-size: 16px
        font-weight: 400
        &.select
            background: linear-gradient(315deg, #FAEA61 0%, #FFB81F 100%)
            color: #282729
        .circle
            position: absolute
            top: 6px
            right: 18px
            width: 8px
            height: 8px
            border-radius: 4px
            background: #FF3973
.p-main
    position: relative
    height: calc(100% - 140px)
    // padding: 20px 20px
    padding: 10px
    .main-box
        text-align: center
        height: 100%
        overflow: auto
        &.with-page
            height: calc(100% - 60px)
    .table_box
        overflow: hidden
        display: inline-block
        margin: 0 auto
        .order_box
            float: left
            text-align: left
            width: 485px
            // padding-left: 30px
            margin: 10px
            color: #282729
            border-radius: 10px
            // box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.09)
            position: relative
            &.empty
                color: #999

            .left_btn
                position: absolute
                left: 1px
                top: 0
        .empty_box
            text-align: center
            padding-top: 180px
            img
                width: 112px
            p
                color: #282729
                &:first-child
                    margin-top: 10px
    .page_box
        position: absolute
        width: calc(100% - 40px)
        height: 60px
        padding: 10px 20px
        bottom: 0
        border: 1px solid #E9E9E9
.row_order
    .order_no
        background: rgba(255, 57, 115, 0.1)
        line-height: 30px
        color: #282729
    .time
        color: #282729
        font-weight: 600
    .color_999
        color: #999
</style>

